import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {CallCenterUsersState} from './types';
import {getters} from './getters';
import {actions} from './actions';
import {mutations} from './mutations';

export const state: CallCenterUsersState = {
  callCenterUsers: [],
};

export const callCenterUsers: Module<CallCenterUsersState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
